import React, { ReactNode } from 'react';

interface FloatingPanelContextType {
    isFloatingPanelVisible: boolean;
    setFloatingPanelVisible: (visible: boolean) => void;
}

export const FloatingPanelContext = React.createContext<FloatingPanelContextType>({
    isFloatingPanelVisible: true,
    setFloatingPanelVisible: () => {},
});

interface FloatingPanelProviderProps {
    children: ReactNode;
}

const FloatingPanelProvider: React.FC<FloatingPanelProviderProps> = ({ children }) => {
    const [isFloatingPanelVisible, setFloatingPanelVisible] = React.useState(true);

    const contextValue = React.useMemo(() => ({ isFloatingPanelVisible, setFloatingPanelVisible }), [isFloatingPanelVisible]);

    return <FloatingPanelContext.Provider value={contextValue}>{children}</FloatingPanelContext.Provider>;
};

FloatingPanelProvider.displayName = 'FloatingPanelProvider';

export { FloatingPanelProvider };
